module.exports = __webpack_public_path__ + "img/5.482e2b3d.png";